import { useState, useEffect } from "react"
import { Container, Row, Col, Card, Button, ListGroup, Form, Alert } from "react-bootstrap"
import { useCheckout } from "../context/CheckoutContext"
import { useNavigate } from "react-router-dom"
import { useCart } from "../context/CartContext"
import { jwtDecode } from "jwt-decode"
import { FaBoxOpen, FaMapMarkerAlt, FaMoneyBillWave, FaHome, FaPlus } from "react-icons/fa"
import { useAuth } from "../context/AuthContext"

const Checkout = () => {
  const { cartItems = [], subtotal = 0, total = 0 } = useCheckout()
  const { clearCart } = useCart()
  const [orderConfirmed, setOrderConfirmed] = useState(false)
  const [addressOption, setAddressOption] = useState("") // "registered" or "new"
  const [address, setAddress] = useState({
    fullName: "",
    phone: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "India",
  })
  const [paymentMethod, setPaymentMethod] = useState("COD")
  const [validated, setValidated] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const navigate = useNavigate()
  const [defaultAddress, setDefaultAddress] = useState({}) 
  const { user, token } = useAuth();

  console.log(user?.address)

  useEffect(() => {
    if (user && user.address) {
      setDefaultAddress(user.address)
    }
  }, [user])

  console.log(defaultAddress)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setAddress({ ...address, [name]: value })
  }

  const handleAddressOptionSelect = (option) => {
    setAddressOption(option)
    if (option === "registered" && defaultAddress) {
      setAddress({
        fullName: defaultAddress.name || "",
        phone: defaultAddress.phone || "",
        street: defaultAddress.address?.street || "",
        city: defaultAddress.address?.city || "",
        state: defaultAddress.address?.state || "",
        zip: defaultAddress.address?.zip || "",
        country: defaultAddress.address?.country || "India",
      })
    } else if (option === "new") {
      setAddress({
        fullName: "",
        phone: "",
        street: "",
        city: "",
        state: "",
        zip: "",
        country: "India",
      })
    }
  }

  const placeOrder = async (useRegisteredAddress = false) => {
    setError(null)
    setSuccess(null)

    if (!useRegisteredAddress && Object.values(address).some((field) => field.trim() === "")) {
      setError("Please fill in all address fields.")
      return
    }

    if (!cartItems.length) {
      setError("Your cart is empty.")
      return
    }

    setIsLoading(true)

    try {
      const token = localStorage.getItem("token")
      if (!token) {
        throw new Error("Please login to place an order.")
      }

      const decoded = jwtDecode(token)
      if (!decoded?.userId) {
        throw new Error("Invalid authentication token.")
      }

      const finalAddress = useRegisteredAddress
        ? {
          fullName: user?.name || "",
          phone: user?.phone || "",
          street: defaultAddress?.street || "",
          city: defaultAddress?.city || "",
          state: defaultAddress?.state || "",
          zip: defaultAddress?.zip || "",
          country: defaultAddress?.country || "India",
        }
        : address

      const formattedCartItems = cartItems.map((item) => ({
        productId: item.productId,
        name: item.name,
        quantity: item.quantity,
        price: item.price,
        images: item.images,
        type: item.type || 'product', // Default to 'product' if not specified
        selectedMachines: item.selectedMachines, // Preserve selected machines
        designCode: item.designCode // Preserve design code
      }))

      
      if (paymentMethod === "Online") {
        const paymentData = {
          userId: decoded.userId,
          username: finalAddress.fullName,
          Mobile: finalAddress.phone,
          orderId: `ORD_${Date.now()}`,
          amount: total,
        }

        console.log("Initiating PhonePe payment:", paymentData)

        const paymentResponse = await fetch("https://madhusewingmachines.com/api/phonepe/addpaymentphonepay", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(paymentData),
        })

        const paymentResult = await paymentResponse.json()
        console.log("Payment response:", paymentResult)

        if (!paymentResponse.ok || paymentResult.error) {
          throw new Error(paymentResult.error || paymentResult.details || "Payment initialization failed")
        }

        
        const orderDataToStore = {
          userId: decoded.userId,
          fullName: finalAddress.fullName,
          phone: finalAddress.phone,
          street: finalAddress.street,
          city: finalAddress.city,
          state: finalAddress.state,
          zip: finalAddress.zip,
          country: finalAddress.country || "India",
          cartItems: formattedCartItems,
          subtotal: subtotal,
          total: total,
          paymentMethod: paymentMethod,
          transactionId: paymentResult.merchantID || paymentResult.orderId,
        }

        localStorage.setItem("pendingOrder", JSON.stringify(orderDataToStore))
        localStorage.setItem("pendingTransactionId", paymentResult.merchantID || paymentResult.orderId)

       
        if (paymentResult.url) {
          window.location.href = paymentResult.url
        } else {
          throw new Error("No payment URL received from server")
        }

        return // Don't proceed - user will be redirected
      }

      // For COD, create order directly
      const orderData = {
        userId: decoded.userId,
        fullName: finalAddress.fullName,
        phone: finalAddress.phone,
        street: finalAddress.street,
        city: finalAddress.city,
        state: finalAddress.state,
        zip: finalAddress.zip,
        country: finalAddress.country || "India",
        cartItems: formattedCartItems,
        subtotal: subtotal,
        total: total,
        paymentMethod: paymentMethod,
        status: "Pending",
      }

      console.log(orderData)

      const response = await fetch("https://madhusewingmachines.com/api/orders", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(orderData),
      })

      const data = await response.json()

      console.log(response)

      if (!response.ok) {
        throw new Error(data.message || `Server responded with ${response.status}`)
      }

      setSuccess("Order placed successfully!")
      setOrderConfirmed(true)
      clearCart()

      setTimeout(() => {
        navigate("/OrderHistory")
      }, 2000)
    } catch (err) {
      console.error("Order placement error:", err)
      setError(err.message || "An error occurred while placing your order.")
    } finally {
      setIsLoading(false)
    }
  }    
  console.log(cartItems)

  const handleProceedToPayment = async (event) => {
    event.preventDefault()
    setValidated(true)
    await placeOrder(false)
  }

  const handleUseRegisteredAddress = async () => {
    await placeOrder(true)
  }

  if (orderConfirmed) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
        <Card className="text-center p-5 shadow" style={{ maxWidth: "600px" }}>
          <Card.Body>
            <h1 className="text-success mb-4">🎉 Order Confirmed!</h1>
            <p className="lead">Your order has been placed successfully.</p>
            <p>Redirecting to your orders page...</p>
          </Card.Body>
        </Card>
      </Container>
    )
  }

  return (
    <Container style={{ marginTop: "80px", maxWidth: "900px" }} className="py-4">
      <Row className="g-4">
        <Col xs={12} lg={6}>
          <Card className="border-0 shadow rounded-4">
            <Card.Header className="bg-dark text-white text-center py-3 rounded-top-4">
              <h4 className="mb-0">
                <FaBoxOpen className="me-2" />
                Your Order
              </h4>
            </Card.Header>
            <Card.Body>
              {cartItems.length > 0 ? (
                <ListGroup variant="flush">
                  {cartItems.map((item, index) => (
                    <ListGroup.Item key={`${item.productId}-${index}`} className="d-flex align-items-center border-0">
                      <img
                        src={
                          item.images && item.images.length > 0
                            ? `https://madhusewingmachines.com/uploads/${item.images[0].url}`
                            : "https://via.placeholder.com/70x70?text=No+Image"
                        }
                        alt={item.name}
                        className="img-fluid rounded shadow-sm"
                        style={{ width: "70px", height: "70px", objectFit: "cover" }}
                        onError={(e) => {
                          e.target.src = "https://via.placeholder.com/70x70?text=No+Image"
                        }}
                      />
                      <div className="ms-3 flex-grow-1">
                        <h6 className="fw-bold mb-0">{item.name}</h6>
                        {item.designCode && (
                          <p className="text-muted small mb-0">Code: {item.designCode}</p>
                        )}
                        <p className="text-muted small mb-0">Qty: {item.quantity}</p>
                        {item.type === 'embroidery-design' && item.selectedMachines && item.selectedMachines.length > 0 && (
                          <div className="mt-1">
                            <small className="text-info">
                              Machines: {item.selectedMachines.map(m => m.name).join(', ')}
                            </small>
                          </div>
                        )}
                      </div>
                      <div className="ms-auto fw-semibold text-success">
                        ₹{(item.price * item.quantity).toLocaleString()}
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              ) : (
                <p className="text-center text-muted">No items in your cart.</p>
              )}
            </Card.Body>
          </Card>

          <Card className="border-0 shadow rounded-4 mt-3">
            <Card.Body>
              <h5 className="mb-3">
                <FaMoneyBillWave className="me-2 text-success" />
                Payment Method
              </h5>
              <Form.Group>
                {/* <Form.Check
                  type="radio"
                  label="Cash on Delivery (COD)"
                  name="paymentMethod"
                  checked={paymentMethod === "COD"}
                  onChange={() => setPaymentMethod("COD")}
                  className="mb-2"
                /> */}
                <Form.Check
                  type="radio"
                  label="Online Payment"
                  name="paymentMethod"
                  checked={paymentMethod === "Online"}
                  onChange={() => setPaymentMethod("Online")}
                />
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} lg={6}>
          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="success">{success}</Alert>}

          {!addressOption && (
            <Card className="border-0 shadow rounded-4 mb-3">
              <Card.Body>
                <h5 className="mb-4 text-center">
                  <FaMapMarkerAlt className="me-2 text-primary" />
                  Choose Delivery Address
                </h5>

                <div className="d-grid gap-3">
                  {user && defaultAddress && defaultAddress.street && (
                    <Card
                      className="border border-primary cursor-pointer"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleAddressOptionSelect("registered")}
                    >
                      <Card.Body className="p-3">
                        <div className="d-flex align-items-center justify-content-between">
                          <div>
                            <h6 className="mb-2">
                              <FaHome className="me-2 text-primary" />
                              Use Registered Address
                            </h6>
                            <p className="mb-0 small text-muted">
                              <strong>{user?.name}</strong>
                              <br />
                              {defaultAddress?.street && `${defaultAddress?.street}, `}
                              {defaultAddress?.city}
                              <br />
                              {defaultAddress?.state && `${defaultAddress?.state} - `}
                              {defaultAddress?.zip}
                              <br />📞 {user?.phone}
                            </p>
                          </div>
                          <Button variant="outline-primary" size="sm">
                            Use This
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  )}

                  <Card
                    className="border border-secondary cursor-pointer"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleAddressOptionSelect("new")}
                  >
                    <Card.Body className="p-3">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <h6 className="mb-2">
                            <FaPlus className="me-2 text-secondary" />
                            Add New Address
                          </h6>
                          <p className="mb-0 small text-muted">Enter a different delivery address</p>
                        </div>
                        <Button variant="outline-secondary" size="sm">
                          Add New
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </Card.Body>
            </Card>
          )}

          {addressOption === "registered" && defaultAddress && (
            <Card className="border-0 shadow rounded-4 mb-3">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <h5 className="mb-0">
                    <FaMapMarkerAlt className="me-2 text-primary" />
                    Delivery Address
                  </h5>
                  <Button variant="outline-secondary" size="sm" onClick={() => setAddressOption("")}>
                    Change
                  </Button>
                </div>
                <div className="bg-light p-3 rounded">
                  <p className="mb-0">
                    <strong>{user?.name}</strong>
                    <br />
                    {defaultAddress?.street}
                    <br />
                    {defaultAddress?.city}, {defaultAddress?.state} - {defaultAddress?.zip}
                    <br />
                    {defaultAddress?.country}
                    <br />📞 {user?.phone}
                  </p>
                </div>
                <Button
                  variant="success"
                  className="w-100 fw-bold py-2 mt-3"
                  onClick={handleUseRegisteredAddress}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Processing...
                    </>
                  ) : (
                    `Place Order - ₹${total.toLocaleString()}`
                  )}
                </Button>
              </Card.Body>
            </Card>
          )}

          {addressOption === "new" && (
            <>
              <Card className="border-0 shadow rounded-4 mb-3">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">
                      <FaMapMarkerAlt className="me-2 text-primary" />
                      New Shipping Address
                    </h5>
                    <Button variant="outline-secondary" size="sm" onClick={() => setAddressOption("")}>
                      Change
                    </Button>
                  </div>
                  <Form noValidate validated={validated}>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3" controlId="fullName">
                          <Form.Label className="fw-semibold">Full Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="fullName"
                            value={address.fullName}
                            onChange={handleInputChange}
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3" controlId="phone">
                          <Form.Label className="fw-semibold">Phone</Form.Label>
                          <Form.Control
                            type="tel"
                            name="phone"
                            value={address.phone}
                            onChange={handleInputChange}
                            required
                            pattern="[0-9]{10}"
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter a valid 10-digit phone number
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-3" controlId="street">
                      <Form.Label className="fw-semibold">Street Address</Form.Label>
                      <Form.Control
                        type="text"
                        name="street"
                        value={address.street}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>

                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3" controlId="city">
                          <Form.Label className="fw-semibold">City</Form.Label>
                          <Form.Control
                            type="text"
                            name="city"
                            value={address.city}
                            onChange={handleInputChange}
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3" controlId="state">
                          <Form.Label className="fw-semibold">State</Form.Label>
                          <Form.Control
                            type="text"
                            name="state"
                            value={address.state}
                            onChange={handleInputChange}
                            required
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3" controlId="zip">
                          <Form.Label className="fw-semibold">Zip Code</Form.Label>
                          <Form.Control
                            type="text"
                            name="zip"
                            value={address.zip}
                            onChange={handleInputChange}
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3" controlId="country">
                          <Form.Label className="fw-semibold">Country</Form.Label>
                          <Form.Control
                            type="text"
                            name="country"
                            value={address.country}
                            onChange={handleInputChange}
                            required
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>

              <Button
                variant="success"
                className="w-100 fw-bold py-2"
                onClick={handleProceedToPayment}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Processing...
                  </>
                ) : (
                  `Place Order - ₹${total.toLocaleString()}`
                )}
              </Button>
            </>
          )}
        </Col>
      </Row>
    </Container>
  )
}

export default Checkout  